module.exports = __webpack_public_path__ + "static/media/skopei.a1557658.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/skopei.svg
// module id = 579
// module chunks = 14